import script from "./PopupBack.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupBack.vue?vue&type=script&setup=true&lang=js"

import "./PopupBack.vue?vue&type=style&index=0&id=43f73a4f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43f73a4f"]])

export default __exports__